import { UPDATE_SESSION } from './types';
const initialState = {
    loggedIn: false,
    session: '',
    userName: '',
};
// eslint-disable-next-line import/prefer-default-export
export function systemReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_SESSION: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        default:
            return state;
    }
}
